// tux styles MUST be imported first: they define every theme CSS variable and
// load the brand fonts that the rest of the app (and Tailwind) depend on.
import '@zyxantech/tux/styles.css'
import './index.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { App } from '@/App'
import { store } from '@/store'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Root element #root not found — index.html is malformed')
}

createRoot(container).render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </Provider>
  </StrictMode>,
)
